// extracted by mini-css-extract-plugin
export default {"container":"play-video_container__3Yq3f","icon":"play-video_icon__3Omvp"};